export const queryKey = {
  USER_INFO: "user_info",
  LANG_LIST: "lang_list",
  ORDER_HISTORY: "order_history",
  ORDER_DETAIL: "order_detail",
  PRODUCT_COUNTRY_LIST: "product_country_list",
  PRODUCT_ITEM_DETAIL: "product_item_detail",
  SUPPORTED_PHONE_BRANDS: "supported_phone_brands",
  SUPPORTED_PHONE_MODEL_LIST: "supported_phone_model_list",
  PRODUCT_ITEM: "product_item",
  DISCOUNT: "discount",
  PROMOTE: "promote",
  LINE_URL: "line_url",
  GIFT_POINT: "gift_point",
  GIFT_POINT_RATIO: "gift_point_ratio",
  PRODUCT_ITEM_METHOD: "product_methods",
  PRODUCT_ITEM_DAYS: "product_days",
  SEO_LIST: "seo_list",
  STORE_CODE: "store_code",
  STORE_CODE_SETTING: "store_code_setting",
  LINE_SIGNIN: "line_signin",
};

export default queryKey;
